module.exports = __webpack_public_path__ + "static/media/biosintex.667558e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/labs/biosintex.png
// module id = 121
// module chunks = 0